import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur bedöms ekonomisk lämplighet?";
const SHORT_ANSWER = "Skatteverket lämnar uppgift om obetalda skatter, skulder och skattebrott. Stora obetalda skulder är ofta tillräckligt för avslag.";

export const Route = createFileRoute("/fraga/nar-bedoms-ekonomisk-lamplighet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur bedöms ekonomisk lämplighet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Även gamla skulder eller upprepade restförda krav kan väga in. Kommunen får också bedöma finansieringen av själva verksamheten – pengar måste komma från redovisad och spårbar källa."}
      source={{ label: "Skatteverket – Personlig och ekonomisk lämplighet", href: "https://www.skatteverket.se/" }}
      extraSources={[{"label": "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", "href": "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/"}]}
      deepGuide={{ to: "/pbi-krets", label: "Ekonomisk lämplighet och PBI" }}
      related={[{"to": "/fraga/vad-ar-vandel", "label": "Vad menas med 'god vandel' i alkohollagen?"}, {"to": "/fraga/far-jag-tillstand-med-skatteskuld", "label": "Kan jag få serveringstillstånd om jag har skatteskuld?"}, {"to": "/fraga/vad-galler-for-finansierare-av-verksamhet", "label": "Räknas finansiärer in i PBI-kretsen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur bedöms ekonomisk lämplighet?" },
      { name: "description", content: "Skatteverket lämnar uppgift om obetalda skatter, skulder och skattebrott. Stora obetalda skulder är ofta tillräckligt för avslag." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/nar-bedoms-ekonomisk-lamplighet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/nar-bedoms-ekonomisk-lamplighet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/nar-bedoms-ekonomisk-lamplighet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur bedöms ekonomisk lämplighet", url: "https://alkoholprovet.se/fraga/nar-bedoms-ekonomisk-lamplighet" },
      ]),
    ],
  }),
});
